export const COUNTRY_RISK_LAYER_STYLES = {
    'default': {
        'risk-country-layer': {
            paint: {
                'fill-color':
                [
                  'case',
                  ['==', ['feature-state', 'riskRating'], 1], 'rgba(0, 0, 0, 0)',
                  ['==', ['feature-state', 'riskRating'], 2], 'rgba(212, 67, 51, 0.1)',
                  ['==', ['feature-state', 'riskRating'], 3], 'rgba(212, 67, 51, 0.2)',
                  ['==', ['feature-state', 'riskRating'], 4], 'rgba(212, 67, 51, 0.5)',
                  ['==', ['feature-state', 'riskRating'], 5], 'rgba(212, 67, 51, 0.8)',
                  'rgba(0, 0, 0, 0)'
                ]
            }
        },
        'country-layer': {
            paint:                 { 
                'fill-color': 'rgba(95, 233, 208, 0.1)',
                'fill-outline-color': '#3CDEC1'
            }
        },
        'country-layer-line': {
            paint:                 { 
                'line-color': '#3CDEC1', 
                'line-width': 6, 
                'line-blur': 4 
            }
        }
    }
}